module.exports = __webpack_public_path__ + "img/binance-home-screen-showing-bitcoin-amount.fbfb65ef.webp";